export default __webpack_public_path__ + "static/media/NeueMontreal-Italic.8fd7779f.otf";